import { render, staticRenderFns } from "./tfAbnormal.vue?vue&type=template&id=50c6aa16&scoped=true"
import script from "./tfAbnormal.vue?vue&type=script&lang=js"
export * from "./tfAbnormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6aa16",
  null
  
)

export default component.exports